const fr = {
    '/': {
        title: '{brand} | Paris Sportifs, Casino Live & Retraits Instantanés',
        description: 'Machines à sous, casino live & paris sportifs chez {brand}. Casino crypto avec retraits instantanés, jeux équitables & support 24/7.'
    },
    '/casino': {
        title: 'Casino en Ligne | Machines à Sous, Blackjack & Croupiers Live | {brand}',
        description: 'Machines à sous, blackjack, roulette & croupiers live chez {brand}. Des centaines de jeux, dépôts crypto rapides & retraits instantanés 24/7.'
    },
    '/sports': {
        title: 'Paris Sportifs en Ligne | Crypto Paris & Cotes | {brand}',
        description: 'Pariez sur le sport chez {brand}. Cotes compétitives sur le football, le basketball & plus. Paris en direct, mises crypto sécurisées & paiements rapides.'
    },
    '/livecasino': {
        title: 'Casino Live | Blackjack, Roulette & Croupiers en Direct | {brand}',
        description: 'Blackjack, roulette & jeux de casino live chez {brand}. Vrais croupiers, streaming HD & une large sélection de tables live disponibles 24/7.'
    },
    '/slots': {
        title: 'Machines à Sous en Ligne | Large Choix de Slots Casino | {brand}',
        description: 'Une immense collection de machines à sous chez {brand}. Machines classiques, vidéo slots & progressives – tous jouables en crypto.'
    },
    '/vip': {
        title: 'Programme VIP | Récompenses Exclusives & Avantages | {brand}',
        description: 'Le programme VIP de {brand} : récompenses exclusives, bonus personnalisés et assistance prioritaire. Avantages pour les joueurs fidèles.'
    },
    '/welcome-offer': {
        title: 'Offre de Bienvenue | Casino Crypto | {brand}',
        description: "Découvrez l'offre de bienvenue de {brand}. Commencez avec de la crypto et profitez d'avantages exclusifs pour les nouveaux joueurs."
    },
    '/referral': {
        title: 'Programme de Parrainage | Gagnez des Récompenses | {brand}',
        description: "Invitez vos amis sur {brand} et gagnez des récompenses lorsqu'ils s'inscrivent et remplissent les conditions."
    },
    '/promotion-page': {
        title: 'Promotions | Bonus & Offres Spéciales | {brand}',
        description: 'Toutes les promotions actives sur {brand}. Bonus, tours gratuits et offres spéciales pour les joueurs crypto.'
    },
    '/hotslots': {
        title: 'Slots Populaires | Machines à Sous les Plus Jouées | {brand}',
        description: 'Jouez aux machines à sous les plus populaires sur {brand}. Les meilleurs slots disponibles avec de la crypto.'
    },
    '/newgames': {
        title: 'Nouveaux Jeux | Derniers Jeux de Casino | {brand}',
        description: 'Découvrez les derniers jeux de casino sur {brand}. Nouveaux slots, jeux en direct et jeux de table ajoutés régulièrement.'
    },
    '/populargames': {
        title: 'Jeux Populaires | Les Jeux de Casino les Plus Joués | {brand}',
        description: 'Les jeux de casino les plus populaires sur {brand}. Des slots aux jeux en direct, tout disponible avec de la crypto.'
    },
    '/gameshows': {
        title: 'Jeux TV | Casino avec Shows en Direct | {brand}',
        description: 'Profitez des meilleurs jeux TV en direct sur {brand}. Présentateurs réels, jeux uniques et grands gains en temps réel.'
    },
    '/table_games': {
        title: 'Jeux de Table | Blackjack, Roulette & Baccarat | {brand}',
        description: "Jouez au blackjack, à la roulette, au baccarat et d'autres jeux de table sur {brand}. Tout disponible avec de la crypto."
    },
    '/hotlive': {
        title: 'Casino en Direct Populaire | Jeux en Direct les Plus Joués | {brand}',
        description: 'Les jeux de casino en direct les plus populaires sur {brand}. Jouez avec de vrais croupiers en temps réel.'
    },
    '/featurebuyin': {
        title: 'Slots avec Achat de Bonus | Feature Buy-in | {brand}',
        description: "Jouez à des slots avec la possibilité d'acheter le bonus sur {brand}. Accédez directement au tour bonus sans attendre."
    }
};
export default fr;
